module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/step3-e5b6fb4582063465d4747ec4aede1083.jpg";